import { Token } from "@/components/token.tsx";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

export function GreenScreen() {
  const { id } = useParams()
  useEffect(() => {
    document.querySelector("body")!.style.background='transparent'
  })
  return (
    <div className="min-w-[1024px] min-h-[1024px] flex justify-center items-center bg-transparent">
      <div id="token" className="w-[1024px] h-[1024px] flex justify-center items-center rounded-xl">
        <Token hq={true} leftAssetId={Number(id)} rightAssetId={0} variant="3xl" glowing={false} />
      </div>
    </div>
  );
}